import { defineComponent as s, ref as i, h as e, Transition as d, withDirectives as h } from "vue";
import f from "./ghl-ui.es1006.js";
import c from "./ghl-ui.es747.js";
import { getPreciseEventTarget as m } from "./ghl-ui.es954.js";
import p from "./ghl-ui.es774.js";
import v from "./ghl-ui.es777.js";
import g from "./ghl-ui.es778.js";
const q = s({
  props: {
    mergedClsPrefix: {
      type: String,
      required: !0
    },
    value: Number,
    monthBeforeYear: {
      type: Boolean,
      required: !0
    },
    calendarMonth: {
      type: String,
      required: !0
    },
    calendarYear: {
      type: String,
      required: !0
    },
    onUpdateValue: {
      type: Function,
      required: !0
    }
  },
  setup() {
    const a = i(null), t = i(null), r = i(!1);
    function o(u) {
      var n;
      r.value && !(!((n = a.value) === null || n === void 0) && n.contains(m(u))) && (r.value = !1);
    }
    function l() {
      r.value = !r.value;
    }
    return {
      show: r,
      triggerRef: a,
      monthPanelRef: t,
      handleHeaderClick: l,
      handleClickOutside: o
    };
  },
  render() {
    const {
      handleClickOutside: a,
      mergedClsPrefix: t
    } = this;
    return e("div", {
      class: `${t}-date-panel-month__month-year`,
      ref: "triggerRef"
    }, e(p, null, {
      default: () => [e(v, null, {
        default: () => e("div", {
          class: [`${t}-date-panel-month__text`, this.show && `${t}-date-panel-month__text--active`],
          onClick: this.handleHeaderClick
        }, this.monthBeforeYear ? [this.calendarMonth, " ", this.calendarYear] : [this.calendarYear, " ", this.calendarMonth])
      }), e(g, {
        show: this.show,
        teleportDisabled: !0
      }, {
        default: () => e(d, {
          name: "fade-in-scale-up-transition",
          appear: !0
        }, {
          default: () => this.show ? h(e(f, {
            ref: "monthPanelRef",
            onUpdateValue: this.onUpdateValue,
            actions: [],
            // month and year click show month type
            type: "month",
            key: "month",
            useAsQuickJump: !0,
            value: this.value
          }), [[c, a, void 0, {
            capture: !0
          }]]) : null
        })
      })]
    }));
  }
});
export {
  q as default
};
